import { render, staticRenderFns } from "./Protector.vue?vue&type=template&id=49f42a24&scoped=true"
import script from "./Protector.vue?vue&type=script&lang=js"
export * from "./Protector.vue?vue&type=script&lang=js"
import style0 from "./Protector.vue?vue&type=style&index=0&id=49f42a24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f42a24",
  null
  
)

export default component.exports